import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'step-type-card',
    templateUrl: 'step-type-card.component.html',
    styleUrls: ['step-type-card.component.scss'],
    standalone: false
})

export class StepTypeCardComponent implements OnInit {

  @Input()
  stepTypeName: string = "";

  constructor() { }

  ngOnInit() { }

}
